export default defineI18nLocale(async locale => {
    return {
    // navbar
        login: 'Login',
        register: 'Register',
        for_company: 'For Company',
        for_jobseeker: 'For Jobseeker',
        dashboard: 'Dashboard',
        all_jobs: 'All Jobs',
        my_job_list: 'My Job List',
        profile: 'Profile',
        notification: 'Notification',
        view_all_notification: 'View All Notification',
        change_password: 'Change Password',
        help_center: 'Help Center',
        logout: 'Logout',
        job_seeker: 'Jobseeker',

        // footer
        contact_information: 'Contact Information',
        privacy_policy: 'Privacy & Policy',
        terms_conditions: 'Terms & Conditions',
        our_service: 'Our Services',
        company: 'Company',
        legal_policy: 'Legal & Policy',

        // landing page
        explore_more_jobs: 'Explore More Job',
        register_now: 'Register Now',
        posted: 'Posted',
        landing_seo_title: 'Samurai Rekrutmen | Work Global, Live Indonesia',
        landing_seo_description: 'Discover career opportunities with international companies—remotely or on-site—designed for globally experienced talent.',
        landing_seo_keywords: 'work global, remote jobs, international careers, job vacancies, japanese experience, careers',
        job_seo_title: 'Job Openings at {monthYear} | Samurai Rekrutmen',
        job_seo_description: 'Find Jobs at Samurai Rekrutmen. Job Openings at {monthYear}',
        job_seo_keywords: 'all jobs, remote jobs, global vacancies, careers',
        job_detail_seo_not_found: 'Job Not Found',
        job_detail_seo_default_description: 'View job details and apply now.',
        job_detail_seo_title: '{jobTitle} at {companyName}, {location} | Samurai Rekrutmen',
        job_detail_seo_description: 'Apply to {jobTitle} at {companyName}, {location}, {category}, {type}',
        job_detail_seo_keywords: '{jobTitle}, {companyName}, job vacancies, global careers, remote work',
        company_seo_not_found: 'Company Not Found',
        company_seo_title: 'Working at {companyName} | Samurai Rekrutmen',
        company_seo_description: 'Search and apply for job openings at {companyName} on Samurai Rekrutmen, the career platform for globally experienced talent.',
        company_seo_keywords: '{companyName}, international company, job vacancies, careers',
        company_job_seo_not_found: 'Company Not Found',
        company_job_seo_default_description: 'View company profile and job openings.',
        company_job_seo_title: 'Job Openings at {companyName} | Samurai Rekrutmen',
        company_job_seo_description: 'Search and apply for jobs at {companyName} on Samurai Rekrutmen, connecting talent with global and remote opportunities.',
        company_job_seo_keywords: 'Job {companyName}, global job openings, careers',
        login_seo_title: 'Login | Samurai Rekrutmen',
        login_seo_description: 'Welcome to Samurai Rekrutmen. Login with your registered account or continue with Google to unlock your career potential.',
        login_seo_keywords: 'login, job seeker, global talent, job vacancies, careers',
        register_seo_title: 'Register | Samurai Rekrutmen',
        register_seo_description: 'Register an Account. Sign up now to create your account and discover exciting global opportunities.',
        register_seo_keywords: 'register, job seeker, create account, global jobs, careers',

        // job
        all_cities: 'All Cities',
        candidates_applied: 'candidates applied',
        views_on_this_job: 'views on this job',
        search_by_keywords: 'Search by keywords',
        search: 'Search',
        previous_slide: 'Previous slide',
        next_slide: 'Next slide',
        open_menu: 'Open menu',
        close_menu: 'Close menu',
        'Welcome to': 'Welcome to',
        'Forgot Password?': 'Forgot Password?',
        Save: 'Save',
        Next: 'Next',
        'Personal Information': 'Personal Information',
        'Almost Done!': 'Almost Done!',
        'Review and make any changes below':
            'Review and make any changes below',
        Edit: 'Edit',
        'Video Introduction': 'Video Introduction',
        'Company Video': 'Company Video',
        'Company Website': 'Company Website',
        'Company Profile': 'Company Profile',
        'List Job': 'List Job',
        'People': 'People',
        'Successfully save job': 'Successfully save job',
        'All Provinces': 'All Provinces',
        'Search job by title': 'Search job by title',
        'See More Jobs': 'See More Jobs',
        'About Company': 'About Company',
        'Company Gallery': 'Company Gallery',
        'COMPANY NAME': 'COMPANY NAME',
        'Your Life in Japan': 'Your Life in Japan',
        'Life in Japan': 'Life in Japan',
        'Your Life': 'Your Life',
        Gender: 'Gender',
        Address: 'Address',
        'Select Region': 'Select Region',
        'Select Specific Location': 'Select Specific Location',
        'Portfolio Link': 'Portfolio Link',
        'Basic Information': 'Basic Information',
        'Additional Information': 'Additional Information',
        'Category Interested': 'Category Interested',
        'Wishing Job Type': 'What job type do you wish',
        Skills: 'Skills',
        make_your_application_stand_out:
            'Make your application stand out by listing your skills. Tap the button below to add what you can do best.',
        'Add Skill': 'Add Skill',
        Languages: 'Languages',
        Language: 'Language',
        Speaking: 'Speaking',
        Writing: 'Writing',
        Listening: 'Listening',
        'Search or enter language': 'Search or enter language',
        "I don't have any": 'I don\'t have any',
        'I am a pass JFT exam': 'I am a pass JFT exam',
        'Pass JFT': 'Pass JFT',
        expand_your_opportunities:
            'Expand your opportunities by showcasing the languages you speak. Click the button below to add the languages.',
        'Add Languages': 'Add Languages',
        'Additional Documents': 'Additional Documents',
        'Upload your additional documents':
            'Upload your additional documents (ex. employment certificate from overseas)',
        'Upload Documents': 'Upload Documents',
        'Education Detail': 'Education Detail',
        'Adding an education section':
            'Adding an education section highlights your qualifications and makes you a stronger candidate',
        'Job Experience': 'Job Experience',
        'japan.experience': 'Working in Japan',
        'Enhance your experience section':
            'Enhancing your experience section can significantly boost your chances of landing your dream job',
        'Key Achievement': 'Key Achievement',
        'Successfully led a cross-functional team... ':
            'Successfully led a cross-functional team... ',
        'Failed to load experiences': 'Failed to load experiences',
        'Failed to load position levels': 'Failed to load position levels',
        'Failed to load job categories': 'Failed to load job categories',
        'Maximum experience is 20': 'Maximum experience is 20',
        Previous: 'Previous',
        Other: 'Other',
        'Example : Name of the LPK, Person Name, etc...': 'Example : Name of the LPK, Person Name, etc...',
        'Skip All': 'Skip All',
        'Skip This Section': 'Skip This Section',
        'Future Plans': 'Future Plans',
        'Your Profile Is Under Review': 'Your Profile Is Under Review',
        'Career Questionnaire': 'Career Questionnaire',
        'Enter Your Future Plans Details': 'Enter Your Future Plans Details',
        'How did you know Samurai Rekrutmen':
            'How did you know Samurai Rekrutmen',
        'When did you depart and come back from Japan':
            'When did you depart and come back from Japan',
        'Add New': 'Add New',
        'Which prefecture were you working in Japan before':
            'Which prefecture were you working in Japan before ? (Longest place you stayed)',
        'What Job Category were you working at':
            'What Job Category were you working at',
        'How many workers were there at your work':
            'How many workers were there at your work',
        'How were the percentage of MEN workers at your work':
            'How were the percentage of MEN workers at your work',
        'How often do you speak Japanese at your work':
            'How often do you speak Japanese at your work',
        'Do you wish to go back to Japan for work again':
            'Do you wish to go back to Japan for work again',
        'How did you spend your day off in Japan':
            'How did you spend your day off in Japan',
        'Which character type do you think you are in working environment':
            'Which character type do you think you are in working environment',
        'Choose the one describes more like yourself in general?': 'Choose the one describes more like yourself in general?',
        'Extraversion or introversion': 'Extraversion or Introversion',
        'Sensing or Intuition': 'Sensing or Intuition',
        'Thinking or Feeling': 'Thinking or Feeling',
        'Judging or Perceiving': 'Judging or Perceiving',
        'About Your Future': 'About Your Future',
        'This section will explain about':
            'This section will explain about what you are expecting in the future so the more matching company will find you easily',
        'Which work style do you prefer in the future':
            'Which work style do you prefer in the future',
        'Which work environment do you prefer':
            'Which work environment do you prefer',
        'Which work environment do you prefer?':
            'Which work environment do you prefer?',
        'Which work environment do you prefer in the future':
            'Which work environment do you prefer',
        'Which work type do you prefer': 'Which work type do you prefer',
        'What are your top 3 interests in work':
            'What are your top 3 interests in work',
        'First Interest': 'First Interest',
        'Second Interest': 'Second Interest',
        'Third Interest': 'Third Interest',
        'Big Category': 'Big Category',
        'Small Category': 'Small Category',
        'This interest has already been selected':
            'This interest has already been selected',
        "Are you willing to try new category of job from what you've done before":
            'Are you willing to try new category of job from what you\'ve done before',
        "Are you willing to try new category of job from what you've done before?":
            'Are you willing to try new category of job from what you\'ve done before?',
        'What are your expectations from the company and your superior':
            'What are your expectations from the company and your superior',
        'Based on your skill and ability, What are your salary expectations':
            'Based on your skill and ability, What are your salary expectations',
        'When would you be available to start if hired':
            'When would you be available to start if hired',
        'Please write your most important thing in life':
            'Please write your most important thing in life',
        'When can you start interviewing?': 'When can you start interviewing?',
        'When can you start working?': 'When can you start working?',
        'What is your career goal?': 'What is your career goal?',
        'Enter your personal information': 'Enter your personal information',
        'Upload Profile Photo': 'Upload Profile Photo',
        'Enter your first name': 'Enter your first name',
        'Enter your last name': 'Enter your last name',
        'Select gender': 'Select gender',
        'Select your region': 'Select your region',
        'Select your province': 'Select your province',
        'Enter your address': 'Enter your address',
        'Enter your email': 'Enter your email',
        'Enter your phone number': 'Enter your phone number',
        'First Name*': 'First Name*',
        'First Name': 'First Name',
        'Last Name*': 'Last Name*',
        'Last Name': 'Last Name',
        'Gender*': 'Gender*',
        'Date of Birth*': 'Date of Birth*',
        'Select date': 'Select date',
        'Select Country': 'Select Country',
        'Select Province': 'Select Province',
        'Address Line 1': 'Address Line 1',
        'Address Line 2': 'Address Line 2',
        'Landmark & City': 'Landmark & City',
        'State/Province': 'State/Province',
        'Zip Code': 'Zip Code',
        'Make this default shipping address': 'Make this default shipping address',
        Country: 'Country',
        Region: 'Region',
        Province: 'Province',
        'Email*': 'Email*',
        'Short Description': 'Short Description',
        'Write a 2–3 sentence summary about yourself and strengths':
            'Write a 2–3 sentence summary about yourself and strengths',
        'Specific Location': 'Specific Location',
        'Job Type': 'Job Type',
        'Add your languages': 'Add your languages',
        'Complete your profile': 'Complete your profile',
        'We see this is your first login, please fill this form':
            'We see this is your first login, please fill this form',
        'Your Future Plans': 'Your Future Plans',
        'Working in Overseas': 'Working in Overseas',
        'Working Abroad': 'Working Abroad',
        Personal: 'Personal',
        Basic: 'Basic',
        Additional: 'Additional',
        'Complete Profile': 'Complete Profile',
        Answered: 'Answered',
        'Write Answer (Ex: Microsoft Skills: Word, Excell, PowerPoint)': 'Write Answer (Ex: Microsoft Skills: Word, Excel, PowerPoint)',
        'Write Answer': 'Write Answer',
        'Choose Answer': 'Choose Answer',
        'Choose answer': 'Choose answer',
        'About Your Life': 'About Your Life',
        'How did you know Samurai Rekrutmen?':
            'How did you know Samurai Rekrutmen?',
        'What are you?': 'What are you?',
        'What Job experience do you have?': 'What Job experience do you have?',
        '(If you are a fresh graduate, part-time job is also allowed)': '(If you are a fresh graduate, part time job is also ok)',
        'Add Job Experience': 'Add Job Experience',
        'What skills can you bring to next job':
            'What skills can you bring to next job?',
        Skill: 'Skill',
        Reason: 'Reason',
        Level: 'Level',
        'work period':
            'In the longest work period, How many workers were there at your work?',
        'Job Category': 'Category',
        'Choose Job': 'Choose Job',
        'greatest achievement':
            'What is your greatest achievement in your previous job?',
        'How do you handle challenges at work':
            'How do you handle challenges at work?',
        'What motivates you in your work': 'What motivates you in your work?',
        'Why did you leave your previous job':
            'Why did you leave your previous job ? (if applicable)',
        'How do you manage your daily life':
            'How do you manage your daily life?',
        morning: 'Morning',
        daytime: 'Daytime',
        evening: 'Evening',
        'Day Off': 'Day Off',
        'province do you prefer to work in Indonesia':
            'Which province do you prefer to work in Indonesia?',
        'province do you prefer to work in Indonesia?':
            'Which province do you prefer to work in Indonesia?',
        'Which province do you prefer to work in Indonesia?':
            'Which province do you prefer to work in Indonesia?',
        'Which province do you prefer to work at in Indonesia?':
            'Which province do you prefer to work at in Indonesia?',
        option: 'Option',
        'About Yourself': 'About Yourself',
        'This section will explain about what kind of person you are':
            'This section will explain about what kind of person you are, so the company can see your potential beside only the skills',
        'Choose the one describes more like yourself in general': 'Choose the one describes more like yourself in general?',
        'Wishes of Future Job': 'Wishes of Future Job',
        'Enter company name': 'Enter company name',
        'Company Name': 'Company Name',
        'Select job category': 'Select job category',
        Category: 'Job Category',
        'Position Level': 'Position Level',
        'Allowed Image': 'Allowed .jpg .jpeg .png and maximum size 2MB',
        'Recommendation tools for edit photo':
            'Recommendation tools for edit photo',
        'Upload Your Resume': 'Upload Your Resume',
        'Enter your basic information': 'Enter your basic information',
        'Skills and Level': 'Skills and Level',
        'Search or enter skill': 'Search or enter skill',
        'Other Skill': 'Other Skill',
        'Select Level': 'Select Level',
        'Select Skills': 'Select Skills',
        'Enter your skill': 'Enter your skill',
        'Employment certificate from overseas':
            'Ex. Employment certificate from overseas',
        'Upload Additional Documents':
            'Upload Additional Documents (PDF Format, max 2MB)',
        Education: 'Education',
        'Add Education': 'Add Education',
        Qualification: 'Qualification',
        'Select qualification': 'Select qualification',
        'Field of Study': 'Field of Study',
        'Search or enter field of study': 'Search or enter field of study',
        'Enter institution name': 'Enter institution name',
        'University / School Name': 'University / School Name',
        'Education Description': 'Education Description',
        'Enter your score': 'Enter your score',
        Score: 'Score',
        'Start Date': 'Start Date',
        'End Date': 'End Date',
        'From date': 'From date',
        Description: 'Description',
        Role: 'Role',
        'Select role': 'Select role',
        'Enter Role Name': 'Enter Role Name',
        'Role Name': 'Role Name',
        'Role Permissions': 'Role Permissions',
        'Administrator Access': 'Administrator Access',
        'Select All': 'Select All',
        Specify: 'Specify',
        'Select specify': 'Select specify',
        'Select position level': 'Select position level',
        'Job Description': 'Job Description',
        'I am still working on this role': 'I am still working on this role',
        'Wishing Location of work place': 'Wishes of Future Job',
        'Date of Birth': 'Date of Birth',
        Answer: 'Answer',
        'Other Informations': 'Other Informations',
        'Life in Overseas & Future Plan': 'Life in Overseas & Future Plan',
        Interest: 'Interest',
        'I am still in Japan': 'I am still in Japan',
        category: 'category',
        'Position and role description': 'Position and role description',
        'We provide automatic generated Resume':
            'We provide automatic generated Resume',
        'Resume detail based from your profile information':
            'Resume detail based from your profile information',
        'Generate Resume': 'Generate Resume',
        'Register an Account': 'Register an Account',
        'Already have an account': 'Already have an account? ',
        Register: 'Register',
        'Remember Me': 'Remember Me',
        Password: 'Password',
        'Confirmation Password': 'Confirmation Password',
        'Do you have work experience in Japan':
            'Do you have work experience in Japan?',
        'Which visa category did you choose to go to Japan?': 'Which visa category did you choose to go to Japan?',
    'Sign in instead': ' Sign in instead',
        'I agree to': 'I agree to',
        'privacy policy': 'privacy policy',
        'terms conditions': 'terms conditions',
        or: 'or',
        'New on our platform': 'New on our platform? ',
        'Create an account': ' Create an account',
        Later: 'Later',
        'Complete Now!': 'Complete Now!',
        'Please complete all forms before saving the data':
            'Please complete all forms before saving the data',
        'Complete Your Information Message':
            'Complete your information to receive job recommendations that match your profile.',
        'Complete Your Information Confirm Message':
            'Complete your information to receive job recommendations that match your profile.',
        'Complete Your Information Confirm Question':
            'Complete Your Personal Information Now?',
        'Complete Your Information Cancel Message': 'Unsubscription Cancelled!',
        Cancel: 'Cancel',
        'Sure, Skip Now': 'Sure, Skip Now',
        'Skip Message':
            'Filling out your details can enhance your chances of getting job recommendations tailored to your profile.',
        'Skip Confirm Message':
            'Complete your information to receive job recommendations that match your profile.',
        'Skip Confirm Question': 'Sure you want to skip?',
        'Skip Cancel Message': 'Unsubscription Cancelled!',
        'Please select region first': 'Please select region first',
        'Uploading Files': 'Uploading Files',
        'What They Have Learned': 'What They Have Learned',
        'What sort of answer would you write if you needed to write here?':
            'What sort of answer would you write if you needed to write here?',
        'Please answer this question in one sentence.':
            'Please answer this question in one sentence.',
        'Welcome back': 'Welcome back',
        'jobs.showing': 'Showing {count} of {total} result',
        'Withdraw Job': 'Yes, Withdraw job',
        'Add More Job  Experience': 'Add More Job Experience',
        'Add More Skill': 'Add More Skill',
        'Are you sure to cancel your subscription?': 'Are you sure to cancel your subscription?',
        'Cannot copy': 'Cannot copy',
        'Create Account': 'Create Account',
        'Enter your additional information': 'Enter your additional information',
        'Maximum score is 100': 'Maximum score is 100',
        'Most applicants': 'Most applicants',
        'Most views': 'Most views',
        'New password cannot be the same as current password': 'New password cannot be the same as current password',
        'No future plans shared yet.': 'No future plans shared yet.',
        'Only PDF and DOC files are allowed': 'Only PDF and DOC files are allowed',
        'Save Card for future billing?': 'Save Card for future billing?',
        'Successfully change password': 'Successfully change password',
        'Successfully remove saved job': 'Successfully remove saved job',
        'Successfully resend verification link': 'Successfully resend verification link',
        'Successfully saved job': 'Successfully saved job',
        'Successfully update job': 'Successfully update job',
        'Successfully update profile!': 'Successfully update profile!',
        'Successfully withdraw from application': 'Successfully withdraw from application',
        'Unsubscription Cancelled!!': 'Unsubscription Cancelled!!',
        'Use as a billing address?': 'Use as a billing address?',
        'User current plan is standard plan': 'User current plan is standard plan',
        'DD MMM YYYY': 'DD MMM YYYY',
        'DD MMM YYYY, hh:mm A': 'DD MMM YYYY, hh:mm A',
        'DD MMM, hh:mm A': 'DD MMM, hh:mm A',
        'DD MMMM YYYY': 'DD MMMM YYYY',
        'MMMM YYYY': 'MMMM YYYY',
        'YYYY-MM-DD': 'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
        'Yesterday, hh:mm A': 'Yesterday, hh:mm A',
        '[Today], hh:mm A': '[Today], hh:mm A',
        '[Yesterday], hh:mm A': '[Yesterday], hh:mm A',
        'INDUSTRY': 'Industry',
        'pdf': 'PDF',
        'submitted...!!': 'Submitted',
        'views': 'Views',
        mark_all_as_read: 'Mark all as read',
        Yes: 'Yes',
        No: 'No',
        'Are you sure?': 'Are you sure?',
        'Want to submit selected jobs for review?': 'Want to submit selected jobs for review?',
        'Submit to Review': 'Submit to Review',
        'Want to re-submit selected jobs for review?': 'Want to re-submit selected jobs for review?',
        'Re-Submit': 'Re-Submit',
        'Want to pause selected jobs?': 'Want to pause selected jobs?',
        'Pause': 'Pause',
        'Want to close selected jobs?': 'Want to close selected jobs?',
        'Close': 'Close',
        'Want to publish selected jobs?': 'Want to publish selected jobs?',
        'Publish': 'Publish',
        'Want to re-open selected jobs?': 'Want to re-open selected jobs?',
        'Re-Open': 'Re-Open',
        'Describe your character...': 'Describe your character...',
        'Describe your work style...': 'Describe your work style...',
        'Which prefecture were you working in Japan before?': 'Which prefecture were you working in Japan before?',
        'Life in Overseas': 'Life in Overseas',
        'Fill your career questionnaire so we can match you with the right companies.':
            'Fill your career questionnaire so we can match you with the right companies.',
        'Which country did you work in?': 'Which country did you work in?',
        'When did you go overseas and return?': 'When did you go overseas and return?',
        'I am still Overseas': 'I am still Overseas',
        'How did you go overseas?': 'How did you go overseas?',
        'Explain how': 'Explain how',
        'Which country did you go to, and what was your visa type?':
            'Which country did you go to, and what was your visa type?',
        'Visa': 'Visa',
        'Tell us what your visa type': 'Tell us what your visa type',
        'Why did you leave your previous job / school studies?':
            'Why did you leave your previous job / school studies?',
        'Which character type do you think you are in working environment?':
            'Which character type do you think you are in working environment?',
        'Which language did you primarily use at work, and how often?':
            'Which language did you primarily use at work, and how often?',
        'Why are you looking for a new job / Why did you return to Indonesia?':
            'Why are you looking for a new job / Why did you return to Indonesia?',
        'What type of workplace culture fits you best? (Select up to 2)':
            'What type of workplace culture fits you best? (Select up to 2)',
        'What are your top 3 interests in work?': 'What are your top 3 interests in work?',
        'Team-oriented': 'Team-oriented',
        'I work best collaborating closely with others': 'I work best collaborating closely with others',
        'Independent': 'Independent',
        'I prefer working with autonomy and self-direction': 'I prefer working with autonomy and self-direction',
        'Structured': 'Structured',
        'I thrive with clear processes and defined roles': 'I thrive with clear processes and defined roles',
        'Flexible': 'Flexible',
        'I prefer adapting and managing my own workload': 'I prefer adapting and managing my own workload',
        'Fast-paced': 'Fast-paced',
        'I enjoy dynamic, high-energy environments': 'I enjoy dynamic, high-energy environments',
        'Stable': 'Stable',
        'I prefer consistent routines and steady-paced work': 'I prefer consistent routines and steady-paced work',
        'Were currently reviewing your profile. Youll be notified as soon as its approved and ready for job applications.': 'We\'re currently reviewing your profile. You\'ll be notified as soon as it\'s approved and ready for job applications.',
        'Your Profile Has Been Rejected': 'Your Profile Has Been Rejected',
        'Loading...': 'Loading...',
        'No data available': 'No data available',
        cv: {
            title: 'Curriculum Vitae',
            name: 'Name',
            dob: 'Date of birth',
            gender: 'Gender',
            nationality: 'Nationality',
            types_of_visas: 'Types of Visas',
            visa: 'Visa',
            period: 'Period',
            period_in_japan: 'Period in Japan',
            target_location: 'Preferred Job Location',
            employment_history: 'Employment History',
            company_name: 'Company name',
            working_period: 'Working Period',
            position_and_duties: 'Position & Duties',
            position: 'Position',
            duties: 'Duties',
            monthly_salary: 'Monthly Salary',
            language_ability: 'Language Ability',
            writing: 'Writing',
            listening: 'Listening',
            speaking: 'Speaking',
            educational_background: 'Educational History',
            computer_skills: 'Computer Skills',
            overseas_experience: 'Overseas Experience',
            overseas_work_history: 'Overseas Work History',
            skills_for_your_next_job: 'Skills for Next Job',
            expected_salary: 'Expected salary',
            negotiable_based_on_responsibilities_and_work_location:
                'per month (negotiable according to responsibilities and work location)',
            target_for_the_next_10_years: 'Career Goals',
            career_goal: 'Career Goals',
            start_interviewing: 'Ready for Interview',
            start_working: 'Ready to Work',
            target_industry: 'Preferred Job Industries',
            available: 'When Can You Start?',
            reason_for_leaving_previous_job: 'Reason for Leaving Previous Job',
            about: 'About Me',
            achievement: 'Achievement',
            'cv.dob': 'Date of Birth',
            'cv.educational_background': 'Educational History',
            'cv.employment_history': 'Employment History',
            'cv.expected_salary': 'Expected Salary',
            'cv.gender': 'Gender',
            'cv.language_ability': 'Language Ability',
            'cv.name': 'Name',
            'cv.nationality': 'Nationality',
            'cv.period_in_japan': 'Period in Japan',
            'cv.target_location': 'Preferred Job Location',
            'cv.skills_for_your_next_job': 'Skills for Next Job',
            'cv.target_for_the_next_10_years': 'Target for the Next 10 Years',
            'cv.title': 'Curriculum Vitae',
            'cv.types_of_visas': 'Types of Visas',
    },

        onboarding_notification: {
            title: 'You haven\'t filled out the profile yet',
            step1: 'Step 1 - About Your Life is not complete yet',
            step2: 'Step 2 - Future Plans is not complete yet',
            step3: 'Step 3 - Personal is not complete yet',
            step4: 'Step 4 - Basic is not complete yet',
            step5: 'Step 5 - Job Experience is not complete yet',
            msg: 'Please fill out & complete your profile so we can match you with the right companies.',
            btn_action: 'Update Now',
    },
        "resume": {
            "useUpload": 'Use Upload Resume',
            "useAutoGenerate": 'Use Auto Generated Resume',
            "autoGenerateDesc": 'We generated Resume based from your account info',
    },

        whyus: {
            section_title: 'Why Samurai Rekrutmen?',
            listing: [
                {
                    title: 'Expert Matching',
                    description: 'We match your specific skills with the right Japanese opportunities.',
        },
                {
                    title: 'Career Growth',
                    description: 'Support for your journey, from application to your future in Japan.',
        },
                {
                    title: 'Trusted Partners',
                    description: 'Connecting you with verified and reliable companies.',
        }
            ]
        },
        'Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars': 'Field must contain at least one uppercase, lowercase and digit with min 6 chars',
        "filter": {
            "filters": "Filters",
            "jobType": "Job Type",
            "jlptLevel": "JLPT Level",
            "jftStatus": "JFT Status",
            "datePosted": "Date Posted",
            "salary": "Salary",
            "specializations": "Specializations",
            "notRequired": "Not Required",
            "needToPass": "Need to Pass",
            "last3Days": "Last 3 Days",
            "last7Days": "Last 7 Days",
            "last30Days": "Last 30 Days",
            "showResult": "Show Result",
            "reset": "Reset"
        },
        "company_not_found": "Company Not Found",
        "company_not_found_desc": "The company profile you are looking for is missing, unavailable, or has been deleted.",
        "page_not_found": "Page Not Found",
        "page_not_found_desc": "Oops, it looks like the page you're searching for has wandered off. You can return to where you left off or use the button below to head back to our homepage and continue your journey.",
        "back_to_home": "Back to Home",
        'Similar Jobs': 'Similar Jobs',
        'Deadline': 'Deadline',
        'Score/GPA': 'Score/GPA',
        'Confirmation': 'Confirmation',
        'Is this information correct?': 'Is this information correct?',
        'Download PDF': 'Download PDF',
        'Read More': 'Read More',
        'Read Less': 'Read Less',
        "I don't have JLPT level": 'I don\'t have JLPT level',
        'Female': 'Female',
        'Male': 'Male',
        "job_not_found": 'Job Not Found',
        "job_not_found_desc": 'The job you are looking for is missing, unavailable, or has been deleted.',
        "back_to_jobs": 'Back to Jobs',
        Apply: 'Apply',
        'Not Required': 'Not Required',
        'Not required': 'Not required',
        'Need to pass': 'Need to pass',
        'Still in Japan': 'Still in Japan',
        'Profile submitted successfully!': 'Profile submitted successfully!',
        'Profile reapplication failed': 'Profile reapplication failed',
        'Failed to update profile data': 'Failed to update profile data',
        'Please complete your profile before continue': 'Please complete your profile before continue',
        'Job Search Results': 'Job Search Results',
        'Computer Skills': 'Computer Skills',
        'At least one education row is required': 'At least one education row is required',
        'At least one experience row is required': 'At least one experience row is required',
        'About Overseas Life': 'About Overseas Life',
        'Do you wish to go back overseas for work again?': 'Do you wish to go back overseas for work again?',
        'What is your status?': 'What is your status?',
        'Why do you think you deserve this salary': 'Why do you think you deserve this salary',
        'What is your career goal': 'What is your career goal',
        'Add Computer Skill': 'Add Computer Skill',
        'Make your application stand out by listing your skills': 'Make your application stand out by listing your skills',
        'Computer Skills (software and tools)': 'Computer Skills (software and tools)',
        'Complete Information': 'Complete Information',
        Email: 'Email',
        'Enter email': 'Enter email',
        'Do you have overseas experience?': 'Do you have overseas experience?',
        'Edit Education': 'Edit Education',
        'Edit Experience': 'Edit Experience',
        'Edit Additional Info': 'Edit Additional Info',
        'Edit Future Plans': 'Edit Future Plans',
        'Job Detail Preview': 'Job Detail Preview',
        'Please note that this page is only a preview of the job detail.':
            'Please note that this page is only a preview of the job detail.',
        'Your Account is Under Review':
            'Your Account is Under Review',
        'Your account is currently under review by our team. Please wait for further updates.':
            'Your account is currently under review by our team. Please wait for further updates.',
        "I'm Understand": 'I\'m Understand',
        'What are the most important things for your future?':
            'What are the most important things for your future?',
        'Write your plans here...': 'Write your plans here...',
        'Copy Text': 'Copy Text',
        Copied: 'Copied',
        'Got it!': 'Got it!',
        'Subscription Successful!': 'Subscription Successful!',
        'Check Your Email': 'Check Your Email',
        'Thank you for subscribing to our newsletter. You will receive the latest job opportunities in your inbox.':
            'Thank you for subscribing to our newsletter. You will receive the latest job opportunities in your inbox.',
        'We have sent a verification link to {email}. Please check your inbox to complete the subscription.':
            'We have sent a verification link to {email}. Please check your inbox to complete the subscription.',
        DETAILS: 'DETAILS',
        Salary: 'Salary',
        'Email Contact': 'Email Contact',
        'Additional Job Info': 'Additional Job Info',
        'JLPT Level': 'JLPT Level',
        'JFT Status Level': 'JFT Status Level',
        'Phone Number': 'Phone Number',
        'Select one': 'Select one',
        'Do you have work experience overseas?': 'Do you have work experience overseas?',
        Continue: 'Continue',
        'Job Status': 'Job Status',
        'Application Status': 'Application Status',
    }
})
